// @flow

export const stubNull = (): null => null;

export const stubValue: { (value: *) : (any) => * } = (value) => () => value;
// is alias for stubValue
export const V = stubValue;
